
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AIcon',
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    width: {
      type: String,
      default: '10px',
    },
    height: {
      type: String,
      default: '10px',
    },
    stroke: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'anz-svg-icon',
    },
  },
})
